/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weird_Teal_Thrush_NudgeInputs */

const fr_weird_teal_thrush_nudge = /** @type {(inputs: Weird_Teal_Thrush_NudgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Records Personnels`)
};

/**

* @param {Weird_Teal_Thrush_NudgeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const weird_teal_thrush_nudge = /** @type {((inputs?: Weird_Teal_Thrush_NudgeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weird_Teal_Thrush_NudgeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_weird_teal_thrush_nudge(inputs)
});